import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../redux/pageSlice";
import { useLocation } from "react-router-dom";
import { LoaderWrap } from "../../Component/GlobalLoader/LoaderWrap";
import "./Careers.css";
import { useVisibilityOnScroll } from "../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../Component/ReuseComponent/TCLines/TC3L";
import { Link } from "react-router-dom";
import GoToBImg from "../../Assets/Svg/Home/HomeS2PBImg.svg";
import { useJobRoutes } from "../../Component/Hooks/RoutesDynamic/RoutesDynamic";
export default function CareersArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchPageData({ page_id: 12, lang: "ar" }));
    }
  }, [dispatch, data]);

  const section1 = data.find((s) => s.section_id === "1");
  const section2 = data.find((s) => s.section_id === "2");
  const section3 = data.find((s) => s.section_id === "3");

  return (
    <>
      <LoaderWrap>
        <div className="CareersContainer">
          <section>
            <CareersS1 section={section1} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CareersS2">
            <CareersS2 contents={section1?.contents} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CareersS3">
            <CareersS3 section={section2} />
          </VisibilitySection>
          <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CareersS4">
            <CareersS4 contents={section2?.contents} />
          </VisibilitySection>
          <VisibilitySection index={4} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CareersS5">
            <CareersS5 section={section3} />
          </VisibilitySection>
          <VisibilitySection index={5} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CareersS6">
            <CareersS6 />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}
function CareersS1({ section }) {
  return (
    <>
      <div className="CareersS1">
        <TC3L Head="المهن" Title={section?.title} TitleWidth="56vw" Para={section?.description} ParaWidth="56vw" />
      </div>
    </>
  );
}

function CareersS2({ contents }) {
  return (
    <>
      <div className="CareersS2">
        <div className="CareersS2P1">
          {contents?.map((item, i) => (
            <CareersS2Box key={item.id || i} Head={item.title} Title={item.description} TitleWidth="30vw" />
          ))}
        </div>
      </div>
    </>
  );
}

function CareersS2Box({ Head, Title, TitleWidth, TitleMobWidth, TitleHeightMob, TitleHeight }) {
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="Cs2BoxC ar">
      <div className="Cs2BoxCH ar TGLo32PxPC">{Head}</div>
      <div className="Cs2BoxCT ar TF20PxSC" style={{ width: isMobile ? TitleMobWidth : TitleWidth, height: isMobile ? TitleHeightMob : TitleHeight }} dir="rtl">
        {Title}
      </div>
    </div>
  );
}

//
function CareersS3({ section }) {
  return (
    <>
      <div className="CareersS3">
        <div className="CarS3P2">
          <TC3L Title={section?.title} />
        </div>
      </div>
    </>
  );
}
function CareersS4({ contents }) {
  return (
    <>
      <div className="CareersS4">
        <div className="CarS4P1 ar">
          {contents?.map((item, i) => (
            <CareersS4Box key={item.id || i} Text={item.description} TitleWidth="30vw" />
          ))}
        </div>
      </div>
    </>
  );
}

function CareersS4Box({ Text }) {
  return <div className="CareersS4Box ar TFut20PxPC">{Text}</div>;
}

function CareersS5({ section }) {
  return (
    <>
      <div className="CareersS5">
        <TC3L Title={section?.title} Para={section?.description} />
      </div>
    </>
  );
}

function CareersS6() {
  const location = useLocation();
  const isArabic = location.pathname.includes("/ar");

  const { jobs, loading, error } = useJobRoutes();

  if (loading) return <div className="CareersS6">Loading jobs...</div>;
  if (error) return <div className="CareersS6">Failed to load jobs: {error}</div>;
  if (!Array.isArray(jobs) || jobs.length === 0) return <div className="CareersS6">No jobs available</div>;

  return (
    <div className="CareersS6 ar">
      {jobs.map((job, index) => (
        <CareersS6Box
          key={index}
          Name={job.JobName}
          Location={job.JobLocation}
          Time={job.JobType}
          Para={job.JobH1Data}
          Path={`/Careers/${job.jobId}${isArabic ? "/ar" : ""}`}
        />
      ))}
    </div>
  );
}
function CareersS6Box({ Name, Location, Time, Para, Path }) {
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    return (
      <>
        <div className="CareersS6Box">
          <div className="CarS6BP1">
            <div className="CarS6BP1F">
              <div className="CarS6BP1Name ar TFut24PxPC">{Name}</div>
            </div>
            <div className="CarS6BP1P2Mob">
              <div className="CarS6BP1S ar TFut16PxPCUC">{Location}</div>
              <div className="CarS6BP1Time ar TFut20PxPC">{Time}</div>
            </div>
          </div>
          <div className="CarS6BP2 ar TF20PxSC">{Para}</div>
          <div className="CarS6BP3">
            <div className="BoxImgTPB_Button">
              <Link to={Path} className="BoxImgTPB_ButtonC Career" dir="rtl">
                <div className="BoxImgTPB_ButtonC_Text ar">اقرأ المزيد</div>

                <div>
                  <img src={GoToBImg} alt="" className="BoxImgTPB_ButtonC_Img Career" style={{ rotate: "180deg" }} />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="CareersS6Box">
        <div className="CarS6BP1 ar">
          <div className="CarS6BP1F">
            <div className="CarS6BP1Name ar TFut24PxPC">{Name}</div>
          </div>
          <div className="CarS6BContainer">
            <div className="CarS6BP1Time ar TFut20PxPC">{Time}</div>
            <div className="CarS6BP1S ar TFut16PxPCUC">{Location}</div>
          </div>
        </div>
        <div className="CarS6BP2 ar TF20PxSC" dir="rtl">
          {Para}
        </div>
        <div className="CarS6BP3">
          <div className="BoxImgTPB_Button">
            <Link to={Path} className="BoxImgTPB_ButtonC" dir="rtl">
              <div className="BoxImgTPB_ButtonC_Text ar">اقرأ المزيد</div>
              <div>
                <img src={GoToBImg} alt="" className="BoxImgTPB_ButtonC_Img" style={{ rotate: "180deg" }} />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
